import React, { useEffect, useState } from "react";
import Socket from "../../Global Functions/socket";
import ChatList from "./chatList";
import ChatComponent from "./chatComponent";
import SearchBar from "../Main/searchBar";
import ChatMirror from "../../Global Functions/chatMirror";
import { useSelector } from "react-redux";
import { ReactComponent as BackIcon } from "../../Assets/Categories/BackIcon.svg";
import { useNavigate } from "react-router-dom";

const ListChats = () => {
  const [selectedBookingId, setSelectedBookingId] = useState(null);

  const { payment_executive } = useSelector((state) => state.admin || {});

  const navigate = useNavigate();

  useEffect(() => {
    Socket.on("connect", () => {
      console.log("Connected to socket:", Socket.id);
    });
  }, []);

  return (
    <div style={{ display: "grid", gridTemplateColumns: "repeat(5,1fr)" }}>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(5,1fr)",
          gridColumn: "1/7",
        }}
      >
        <div
          className="backicon-external"
          style={{ gridColumn: "1/2", margin: "20px auto 0px 20px" }}
        >
          <div onClick={() => navigate(-1)}>
            <BackIcon style={{ cursor: "pointer" }} />
          </div>
          <div className="backicon-internal">
            <h1 className="backicon-internal_h1">Chats</h1>
          </div>
        </div>
        <div style={{ gridColumn: "2/6", margin: "20px 20px 0px 0px" }}>
          <SearchBar></SearchBar>
        </div>
      </div>

      <div style={{ gridColumn: "1/8" }}>
        <ChatMirror
          emailAddress={payment_executive?.data?.email}
          phone={payment_executive?.data?.contact_number}
        ></ChatMirror>
      </div>
      <ChatList
        style={{ gridColumn: "1/2" }}
        setSelectedBookingId={setSelectedBookingId}
      ></ChatList>
      <ChatComponent
        style={{ gridColumn: "3/5" }}
        selectedBookingId={selectedBookingId}
      ></ChatComponent>
    </div>
  );
};

export default ListChats;
